/**
 * Binds pricing plan tabs and their related panels.
 *
 * @param {Object} options Configuration object.
 * @param {NodeListOf<HTMLButtonElement>} options.tabs    Plan tab buttons.
 * @param {NodeListOf<HTMLElement>} options.panels        Plan tab panels.
 * @param {Function} options.onChange                     Callback fired after tab change.
 * @return {void}
 */
export const bindTabs = ( { tabs, panels, onChange } ) => {

	/**
	 * Activates the selected tab and its related panel.
	 *
	 * @param {HTMLButtonElement} activeTab Tab that should become active.
	 * @return {void}
	 */
	const activateTab = ( activeTab ) => {

		const nextMode = activeTab.dataset.plan || 'core';

		tabs.forEach( ( tab ) => {

			const isActive = tab === activeTab;

			tab.classList.toggle( 'b-pricing-calculator__plan-tab--active', isActive );
			tab.setAttribute( 'aria-selected', String( isActive ) );
			tab.setAttribute( 'tabindex', isActive ? '0' : '-1' );

		} );

		panels.forEach( ( panel ) => {

			panel.toggleAttribute( 'hidden', panel.dataset.mode !== nextMode );

		} );

		onChange( nextMode );

	};

	/**
	 * Activates the next or previous tab using keyboard navigation.
	 *
	 * @param {HTMLButtonElement} currentTab Current focused tab.
	 * @param {number} direction Navigation direction.
	 * @return {void}
	 */
	const moveFocus = ( currentTab, direction ) => {

		const tabList = [ ...tabs ];
		const currentIndex = tabList.indexOf( currentTab );

		if ( currentIndex < 0 ) {

			return;

		}

		const nextIndex = ( currentIndex + direction + tabList.length ) % tabList.length;
		const nextTab = tabList[ nextIndex ];

		activateTab( nextTab );
		nextTab.focus();

	};

	tabs.forEach( ( tab ) => {

		tab.addEventListener( 'click', () => {

			activateTab( tab );

		} );

		tab.addEventListener( 'keydown', ( event ) => {

			if ( event.key === 'ArrowRight' || event.key === 'ArrowDown' ) {

				event.preventDefault();
				moveFocus( tab, 1 );

			} else if ( event.key === 'ArrowLeft' || event.key === 'ArrowUp' ) {

				event.preventDefault();
				moveFocus( tab, -1 );

			}

		} );

	} );

};
